import { Injectable,Inject } from '@angular/core';
import { Router } from '@angular/router';
import 'rxjs/add/operator/filter';
import { Http, RequestOptions, Headers } from '@angular/http'
import { Observable } from 'rxjs';

@Injectable()
export class AuthService {
  public DEFAULT_USER_IMG:string = 'assets/images/default_user.png';
  auth0:any;

  user:any = {};
  userProfile: any;
  firebase_auth:any;
  refreshSubscription: any;

  
  constructor(private http: Http,public router: Router) {
    
    
  }

  public login(): void {
    
  }

  

  public logout(): void {
    // Remove tokens and expiry time from localStorage
   
  }

  public isAuthenticated(): boolean {
    return true;
  }



}


// WEBPACK FOOTER //
// /Users/andrescufari/Angular/billbo-desktop-v2/src/app/services/auth.service.ts